import { render, staticRenderFns } from "./BlockchainCryptoBadge.vue?vue&type=template&id=912a4faa&scoped=true&"
import script from "./BlockchainCryptoBadge.vue?vue&type=script&lang=js&"
export * from "./BlockchainCryptoBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912a4faa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
